var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHexagonHover(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 228,
    height: 60,
    viewBox: "0 0 228 60",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_180235",
    "data-name": "Group 180235",
    transform: "translate(0 20)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_179145",
    "data-name": "Group 179145"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_6641",
    "data-name": "Rectangle 6641",
    fill: "#f0f5f8",
    stroke: "#e1e1e1",
    strokeWidth: 1,
    strokeDasharray: "2 2"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 228,
    height: 40,
    rx: 4,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 227,
    height: 39,
    rx: 3.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Polygon_26",
    "data-name": "Polygon 26",
    transform: "translate(105 12)",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.946,0l4.649,8-4.649,8h-9.3L0,8,4.649,0Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 5.799622535705566 2 L 2.313135147094727 8 L 5.799622535705566 14 L 12.79497146606445 14 L 16.28145980834961 8 L 12.79497146606445 2 L 5.799622535705566 2 M 4.648647308349609 0 L 13.94594764709473 0 L 18.59459686279297 8 L 13.94594764709473 16 L 4.648647308349609 16 L -1.9073486328125e-06 8 L 4.648647308349609 0 Z",
    stroke: "none",
    fill: "#1e1e1e"
  }))), /*#__PURE__*/React.createElement("text", {
    id: "Hexagon",
    transform: "translate(0 -10)",
    fill: "#54565c",
    fontSize: 10,
    fontFamily: "NunitoSans-Regular, Nunito Sans"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Hexagon")))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHexagonHover);
export default __webpack_public_path__ + "static/media/HexagonHover.3e38e3464217ea521cfe65c094ff5426.svg";
export { ForwardRef as ReactComponent };